// extracted by mini-css-extract-plugin
export var dropdownIcon = "_mi-6";
export var imgContainer = "_mi-3";
export var menuIcon = "_mi-5";
export var pillWrapper = "_mi-2";
export var pillsContainer = "_mi-1";
export var subscriptionCard = "_mi-0";
export var subscriptionLogo = "_mi-4";